import { Button, Card, Tooltip } from '@blueprintjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const ProfileTransfer = ({
  sourceOrganisation,
  destinationOrganisation,
  profile,
  canAcceptTransfers,
  onApprove,
  onReject,
}) => {
  const { t } = useTranslation();

  return (
    <Card className={styles.profileTransferContainer}>
      <div className={styles.contentContainer}>
        <p className={styles.name}>
          {`${profile.firstname} ${profile.lastname}`}
        </p>
        <p>{profile.employment_position}</p>
        <p className={styles.transfer}>
          {sourceOrganisation}{' '}
          <FontAwesomeIcon className="mx-1" icon="arrow-right" />{' '}
          {destinationOrganisation}
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <Tooltip
          content={
            !canAcceptTransfers
              ? t('You do not have permission to accept transfers')
              : ''
          }
          disabled={canAcceptTransfers}
        >
          <Button
            intent="success"
            disabled={!canAcceptTransfers}
            icon={canAcceptTransfers ? null : 'lock'}
            onClick={canAcceptTransfers ? onApprove : undefined}
          >
            {t('Approve')}
          </Button>
        </Tooltip>
        <Tooltip
          content={
            !canAcceptTransfers
              ? t('You do not have permission to reject transfers')
              : ''
          }
          disabled={canAcceptTransfers}
        >
          <Button
            intent="danger"
            icon={canAcceptTransfers ? null : 'lock'}
            disabled={!canAcceptTransfers}
            onClick={canAcceptTransfers ? onReject : undefined}
          >
            {t('Reject')}
          </Button>
        </Tooltip>
      </div>
    </Card>
  );
};

export default ProfileTransfer;
